import { useState } from "react";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import {
  dashboard,
  activedashboard,
  Employees,
  activeEmpolyees,
  ProvisionTenantsIcon,
  activeProvisionTenants,
  reportsIcon,
  reportsActiveIcon,
  settingIcon,
  settingActiveIcon, // ✅ add this
  helpIcon,
  helpActiveIcon, // ✅ add this
  menubar,
  close,
  LogOut,
  DiscountManagementIcon,
  ActiveDiscountManagementIcon,
  feedbackTriageIcon,
  activeFeedbackTriageIcon,
  securityIcon,
  activeSecurityIcon,
  collapseIcon,
  LogOutIcon,
} from "../assets/icons";
import webLogo from "../assets/images/HomeLogo.svg";
import mobileLogo from "../assets/images/HomeSidebarLogo.svg";
import { useSidebar } from "../context/SidebarContext";
import { useDispatch, useSelector } from "react-redux";
import { routes } from "../helpers/constants";
import { logout } from "../redux/slices.js/admins/adminsSlice";
import Modal from "./Modal";

const links = [
  {
    name: "Dashboard",
    path: "/dashboard",
    icon: dashboard,
    activeIcon: activedashboard,
  },
  {
    name: "Tenants",
    path: "/tenants",
    icon: Employees,
    activeIcon: activeEmpolyees,
  },
  {
    name: "Provision Tenants",
    path: "/provision-tenants",
    icon: ProvisionTenantsIcon,
    activeIcon: activeProvisionTenants,
  },
  {
    name: "Discount management",
    path: "/discount-management",
    icon: DiscountManagementIcon,
    activeIcon: ActiveDiscountManagementIcon,
  },
  {
    name: "Feedback triage ",
    path: "/feedback-triage",
    icon: feedbackTriageIcon,
    activeIcon: activeFeedbackTriageIcon,
  },
  {
    name: "Security",
    path: "/security",
    icon: securityIcon,
    activeIcon: activeSecurityIcon,
  },
  {
    name: "Reports",
    path: "/reports",
    icon: reportsIcon,
    activeIcon: reportsActiveIcon,
  },
];

const SideBar = ({ isOpen, toggleSidebar }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isSidebarOpen } = useSidebar();
  const [isSettingsOpen, setIsSettingsOpen] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const location = useLocation();

  const handleLogout = () => {
    dispatch(logout());
  };

  const allowdRoleBasedRoutes = useSelector(
    (state) => state.roles?.items || []
  );
  const alwaysInclude = [
    "Dashboard",
    "Tenants",
    "Staff",
    "Promotions",
    "Provision Tenants",
    "Reports",
    "Discount management",
  ];

  // const filteredLinks = links.filter((link) => {
  //   if (alwaysInclude.includes(link.name)) return true;
  //   return allowdRoleBasedRoutes.some(
  //     (item) => item?.module === link.name && item?.read
  //   );
  // });

  return (
    <>
      <div
        className={`flex-none fixed w-[265px] inset-y-0 left-0 z-[999] transform 
      ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"}
      ${isOpen ? "translate-x-0" : "-translate-x-full"} 
      transition-transform duration-300 lg:translate-x-0 lg:relative lg:inset-0 
      ${isOpen ? "lg:w-[265px]" : "lg:w-20"}
      bg-black-900 flex flex-col transition-all px-3 h-screen overflow-auto`}
      >
        {/* Header */}
        <div className="h-16 flex-none flex items-center justify-between font-bold text-lg border-b border-[#DADADA0F]">
          <Link to="/">
            <img
              src={isOpen ? webLogo : mobileLogo}
              alt="logo"
              className="h-[20px]"
            />
          </Link>
          <button onClick={toggleSidebar} className="border-none outline-none">
            {isOpen ? collapseIcon : menubar}
          </button>
        </div>

        {/* Main Menu */}
        <nav className="mt-6">
          <ul className="mb-[150px]">
            {links.map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <li key={item.name}>
                  <NavLink
                    to={item.path}
                    className={({ isActive }) =>
                      `flex ${
                        isOpen ? "" : "justify-center"
                      } items-center gap-3 py-[10px] px-3 rounded-full cursor-pointer transition text-span !font-semibold ${
                        isActive ? "bg-yellow text-blue-100" : "text-gray-100"
                      }`
                    }
                  >
                    {({ isActive }) => (
                      <>
                        {isActive ? item.activeIcon : item.icon}
                        {isOpen && <span className="font-medium">{item.name}</span>}
                      </>
                    )}
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </nav>

        {/* Settings Section */}
        <div className="flex-1 mb-6 border-t border-[#DADADA0F]">
          <ul className="mt-[23px]">
            <li>
              <ul className="ps-0 mt-1 space-y-2 text-gray-100">
                {/* Settings */}
                <li
                  className={`flex items-center ${
                    isOpen ? "" : "justify-center"
                  } gap-3 py-[10px] px-3 rounded-full cursor-pointer text-span !font-semibold ${
                    location.pathname.includes("setting")
                      ? "bg-yellow text-blue-100"
                      : "text-gray-100"
                  }`}
                  onClick={() => navigate(routes.setting)}
                  // onClick={() => navigate(routes.plan)}
                >
                  {location.pathname.includes("setting")
                    ? settingActiveIcon
                    : settingIcon}
                  {isOpen && isSettingsOpen && <span>Settings</span>}
                </li>

                {/* Help */}
                <li
                  className={`flex items-center ${
                    isOpen ? "" : "justify-center"
                  } gap-3 py-[10px] px-3 rounded-full cursor-pointer text-span !font-semibold ${
                    location.pathname.includes("help")
                      ? "bg-yellow text-blue-100"
                      : "text-gray-100"
                  }`}
                  onClick={() => navigate(routes.help)}
                >
                  {location.pathname.includes("help")
                    ? helpActiveIcon
                    : helpIcon}
                  {isOpen && <span>Help</span>}
                </li>
              </ul>
            </li>
          </ul>
        </div>

        {/* Logout */}
        <div
          className="flex items-center gap-3 py-3 cursor-pointer border-t border-[#DADADA0F]"
          onClick={() => setShowModal(true)}
        >
          <div className="flex items-center gap-3 py-[10px] px-3 rounded-full cursor-pointer transition text-span !font-semibold text-gray-100">
            {LogOut}
            {isOpen && <span>Log out</span>}
          </div>
        </div>
      </div>
      <Modal
        show={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={() => {
          handleLogout();
          setShowModal(false);
        }}
        Icon={LogOutIcon}
        // ModalTitle={`logout`}
        title={`Are you sure you want to logout?`}
      />
    </>
  );
};

export default SideBar;
